import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks';
import LockIcon from '@mui/icons-material/Lock';
import HomeIcon from '@mui/icons-material/Home';
import { usePermissionsContext } from '../../providers/PermissionsProvider';

const PermissionRoute = ({
  children,
  screen,
  action = 'VIEW',
  requiresRoot = false,
  requiresEM = false,
  requiresLRM = false,
  requiresCM = false,
  redirectTo = '/unauthorized',
}) => {
  const { t } = useTranslation();
  const { hasPermission, initialized } = usePermissionsContext();
  const { user } = useAuth();

  if (!initialized) {
    return null;
  }

  if (requiresLRM && user?.isLoanRequestManager === true) {
    return children;
  }

  if (requiresRoot && user?.role !== 'ROOT') {
    return <UnauthorizedPage />;
  }
  if (requiresEM && user?.is_expense_manager !== true) {
    return <UnauthorizedPage />;
  }
  if (requiresCM) {
    if (user?.role === 'ROOT' || user?.manages_collections === true) {
      return children;
    }
    return <UnauthorizedPage />;
  }

  if (screen && !hasPermission(screen, action)) {
    return <UnauthorizedPage />;
  }

  return children;
};

const UnauthorizedPage = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        gap: 3,
        px: 3,
      }}
    >
      <Box
        sx={{
          p: 3,
          borderRadius: '50%',
          bgcolor: 'error.light',
          color: 'error.contrastText',
        }}
      >
        <LockIcon sx={{ fontSize: 48 }} />
      </Box>

      <Box>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          {t('errors.unauthorized.title', 'Yetkisiz Erişim')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ maxWidth: 400 }}
        >
          {t(
            'errors.unauthorized.message',
            'Bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen sistem yöneticinizle iletişime geçin.'
          )}
        </Typography>
      </Box>

      <Button
        variant="contained"
        startIcon={<HomeIcon />}
        onClick={() => (window.location.href = '/')}
        size="large"
      >
        {t('errors.unauthorized.goHome', 'Ana Sayfaya Dön')}
      </Button>
    </Box>
  );
};

export default PermissionRoute;
